import { Table, Tag, Space, Button, Input } from 'antd';
import {PlusOutlined} from "@ant-design/icons";
import { Pagination } from 'antd';





export default function TableComponent({columns, data, clickAddButton, clickRow, loading, onSearch, search, onChange }){

    function onClick(data){
        clickRow(data);
    }

    function onSearchTable(value){
        onSearch(value);
    }

    function onChangePage(pageNumber) {
        console.log('Page: ', pageNumber);
        onChange({page: pageNumber, perPage: 10000 })
    }

    return (
        <>

            {search && (
                <div className="search">
                    <Input.Group compact>
                        <Input.Search

                            placeHolder={"Aramak istediğiniz kelimeyi giriniz"}
                            enterButton={true}
                            loading={loading}
                            onSearch={onSearchTable}
                        />
                    </Input.Group>
                </div>
            )}




            <Table
                columns={columns}
                dataSource={data.items}
                pagination={false}
                loading={loading}
                rowKey={"id"}
                scroll={{ x: 2000, y: 500 }}
            />

        </>



    )
}

